import { store } from '@updater/auth';
import { Session } from './session';

// use cookie based persistence of session
export function persistAuth() {
  if (typeof window === 'undefined') return;
  const session = Session.read();
  if (session) {
    store.setSession({ mode: 'anonymous', session });
  }

  // sync changes to local cache
  store.subscribe(({ session }) => {
    if (session) {
      Session.write(session);
    } else {
      Session.write();
    }
  });
}
